import { forwardRef } from 'react';

import { isIOS, isSafari } from '@rikstv/play-common/src/utils/device/device.utils';

import styles from './SwimlanePlaceholder.module.css';

export const SwimlanePlaceholder = forwardRef<
  HTMLDivElement,
  { active: boolean; animationDelay?: number; children?: React.ReactNode }
>(({ active, animationDelay = 0, children }, ref) => {
  const isApple = isIOS || isSafari;

  if (active) {
    return (
      <div className={styles.commonPageSwimlanePlaceholder}>
        <div
          ref={ref}
          aria-live="polite"
          aria-busy="true"
          className={styles.commonPageSwimlanePlaceholderContent}
          style={{
            animationDelay: `${animationDelay * 75}ms`,
            //set animationIterationCount = 0 for apple because of performance issues
            animationIterationCount: isApple ? '0' : 'infinite',
          }}>
          <p className="sr-only">Laster inn karusell</p>
          {children}
        </div>
      </div>
    );
  }

  return <>{children}</>;
});
